<template>
    <div class="form-control-root cic-csv-import">
        <label v-if="label" :for="inputId" class="form-control-label">{{ label }}</label>
        <div class="form-control-input">
            <ElInput
                :id="inputId"
                type="file"
                :enabled="enabled"
                :accept="options.map((opt) => `.${opt}`).join(',')"
                @input="onChange"
            />
        </div>
        <div v-if="helpText" :title="helpText"><QuestionFilled class="el-icon-filled el-icon-no-pointer" /></div>
    </div>
</template>

<script>
    import { ElInput } from 'element-plus';
    import { QuestionFilled } from '@element-plus/icons-vue';
    import { parse } from 'csv-parse/browser/esm/sync';
    import { showErrorMessage, showValidationMessage } from '@/utils/Notification';

    export default {
        name: 'CicCsvImport',
        components: {
            ElInput,
            QuestionFilled,
        },
        props: {
            inputId: {
                type: String,
                required: true,
            },
            label: {
                type: String,
                default: undefined,
            },
            enabled: {
                type: Boolean,
                default: true,
            },
            options: {
                type: Array,
                default: () => ['csv'],
            },
            helpText: {
                type: String,
                default: undefined,
            },
            numColumns: {
                type: Number,
                default: 1,
            },
        },
        emits: ['change'],
        methods: {
            async onChange() {
                const fileObj = document.getElementById(this.inputId);

                if (!fileObj?.files || fileObj.files?.length === 0) {
                    showErrorMessage(this.$t('Failed to read file'));
                    return;
                }

                fileObj.files[0].text().then(this.fileOnLoad, () => {
                    showErrorMessage(this.$t('Failed to read file'));
                });
            },

            fileOnLoad(content) {
                try {
                    let imported = parse(content, { skip_empty_lines: true });

                    if (imported.length === 0) {
                        showErrorMessage(this.$t('CSV_PARSE_FAILED'));
                        return;
                    }

                    if (imported.some((row) => row.length !== this.numColumns)) {
                        showValidationMessage('Incorrect number of columns');
                        return;
                    }

                    this.$emit('change', this.numColumns === 1 ? imported.map((row) => row[0]) : imported);
                } catch (err) {
                    showErrorMessage(this.$t('CSV_PARSE_FAILED'));
                }
            },
        },
    };
</script>
